import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import {useEffect} from "react"
import AddEditTS from "../../components/TestStation/AddEdit"
import TestStationsGrid from "../../components/TestStation/Grid"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {getTestStationsById} from "./testStationSlice"

const TestStations = () => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(getTestStationsById())
    }, [dispatch])

    const loading = useAppSelector((state: RootState) => state.containers.testStations.loading)

    const loadingPanel = (
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
    )

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Test stations</MDBBreadcrumbItem>
            </MDBBreadcrumb>

            {loading && loadingPanel}
            <TestStationsGrid />
            <AddEditTS />
        </>
    )
}

export default TestStations
